import { render, staticRenderFns } from "./SectionWithAccordionList.vue?vue&type=template&id=267a5b54&"
import script from "./SectionWithAccordionList.vue?vue&type=script&lang=js&"
export * from "./SectionWithAccordionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports